<div [class.dark-theme]="themeService.isDark()">
    <ng-template *ngIf="!isLoggedIn">
        <app-navbar></app-navbar>
    </ng-template>
    
    <router-outlet></router-outlet>
    <app-footer *ngIf="!(location == '/login' || location == '/register' || location == '/coming-soon')"></app-footer>
    <app-theme-customizer></app-theme-customizer>
</div>